if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;

        // === Tambahan: deteksi perubahan varian ===
        const variantIdInput = this.form.querySelector('[name="id"]');
        if (variantIdInput) {
          const observer = new MutationObserver(() => {
            const event = new CustomEvent("product:variant-change", {
              detail: { variantId: variantIdInput.value },
            });
            document.dispatchEvent(event);

            // Tunda sedikit, lalu terapkan minQty setelah varian selesai di-render
            setTimeout(() => this.applyMinQty(), 250);
          });
          observer.observe(variantIdInput, {
            attributes: true,
            attributeFilter: ["value"],
          });
        }

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // === Inisialisasi awal enforce min qty ===
        setTimeout(() => this.applyMinQty(), 300);

        // === Tambahan: observer global untuk mendeteksi qty input baru ===
        const bodyObserver = new MutationObserver(() => {
          const qtyInput = document.querySelector('input[name="quantity"]');
          if (qtyInput && !qtyInput._minQtyHandled) {
            qtyInput._minQtyHandled = true;
            setTimeout(() => this.applyMinQty(), 150);
          }
        });
        bodyObserver.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // === Tambahan method: enforce minimum quantity untuk varian tertentu ===
      applyMinQty() {
        const qtyInput = document.querySelector('input[name="quantity"]');
        const minusBtn = document.querySelector(
          '.quantity__button[name="minus"]'
        );
        if (!qtyInput) return;

        // --- Hitung varian aktif setiap kali fungsi dipanggil ---
        const idInput = this.form.querySelector('[name="id"]');
        const curId = idInput?.value;
        const vp = window.visibleProduct;
        let joinedOptions = "";

        if (vp && vp.variants) {
          const variant = vp.variants.find(
            (v) => String(v.id) === String(curId)
          );
          if (variant) {
            joinedOptions = [variant.option1, variant.option2, variant.option3]
              .filter(Boolean)
              .join(" ")
              .toLowerCase();
          }
        }

        // HANYA varian yang benar-benar Duo Plus (Lite/Edge/Prime termasuk)
        const isDuoPlus = /\bduo\s*plus\b/.test(joinedOptions);
        const minQty = isDuoPlus ? 2 : 1;
        const minStr = String(minQty);

        // --- Penting: set keduanya (min & data-min), karena theme clamp ke data-min ---
        if (qtyInput.min !== minStr) qtyInput.min = minStr;
        if (qtyInput.getAttribute("min") !== minStr)
          qtyInput.setAttribute("min", minStr);
        if (qtyInput.dataset.min !== minStr) {
          qtyInput.dataset.min = minStr;
          qtyInput.setAttribute("data-min", minStr);
        }

        // Clamp nilai ke minimum saat ini
        if ((parseInt(qtyInput.value, 10) || 0) < minQty) {
          qtyInput.value = minStr;
          qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
          qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // === Pastikan tombol minus sesuai kondisi terbaru ===
        if (minusBtn) {
          const currentQty = Number(qtyInput.value || 0);

          // Hanya berlaku untuk varian Duo Plus
          if (isDuoPlus) {
            const disabled = currentQty <= minQty;
            minusBtn.disabled = disabled;
            minusBtn.setAttribute("aria-disabled", disabled ? "true" : "false");
          } else {
            // Untuk varian lain: tombol minus normal
            minusBtn.disabled = currentQty <= 1;
            minusBtn.setAttribute(
              "aria-disabled",
              currentQty <= 1 ? "true" : "false"
            );
          }

          // === Tambahkan listener sekali saja agar real-time ===
          if (!qtyInput._minusBtnSync) {
            qtyInput._minusBtnSync = true;

            // Saat user ubah input manual
            qtyInput.addEventListener("input", () => this.applyMinQty());

            // Saat user klik tombol plus/minus
            document.querySelectorAll(".quantity__button").forEach((btn) => {
              btn.addEventListener("click", () => {
                // Delay sedikit biar quantity berubah dulu
                setTimeout(() => this.applyMinQty(), 100);
              });
            });
          }
        }

        // Observer ringan untuk mencegah theme mengembalikan ke 1.
        // Penting: observer memanggil applyMinQty() lagi (re-evaluasi isDuoPlus), TIDAK menyimpan state lama.
        if (!qtyInput._duoQtyObs) {
          qtyInput._duoQtyObs = new MutationObserver(() => {
            // setiap perubahan min/value/data-min → evaluasi ulang
            this.applyMinQty();
          });
          qtyInput._duoQtyObs.observe(qtyInput, {
            attributes: true,
            attributeFilter: ["min", "data-min", "value"],
          });
        }
      }
    }
  );
}
